export * from "@vaadin/switch/vaadin-switch.js";
/**
 * @license
 * Copyright (c) 2022 - 2026 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

export * from './generated/Switch.js';
